
<template>
    <div>
        <el-row :gutter="20">
            <el-col v-show="collapse == 0" :span="3" style="border-rigth: 1px #solid #ccc">
                <div :style="{ height: screenHeight + 'px', position: 'relative', background: '#e0f2f1' }">
                    <div v-for="item in surgeries" :key="item.id" class="surgery-patient-list" style="padding-top: 10px" :class="{ surgeryActive: item.id == defaultSurgeryId }">
                        <el-row>
                            <div class="cursor-pointer" @click="ReloadDocument(item.id)">
                                <el-col :span="24" class="padding5 padding-none-v align-left" :title="titleLabel(item)">
                                    <div class="ellipsis">
                                        <b>
                                            {{ `${item.patient_name}(${item.sex || '--'}` }}
                                            <i style="color: red !important">/</i>{{ ` ${item.age || '--'} ` }} <i style="color: red !important">/</i>{{ ` ${item.bed_no || '--'}床 ` }}
                                            <i style="color: red !important">/</i>{{ ` ${item.visit_no})` }}
                                        </b>
                                    </div>
                                    <div>
                                        <b class="ellipsis">{{ item.surgeries }}</b>
                                    </div>
                                    <div>
                                        <b class="ellipsis">{{ item.diseases }}</b>
                                    </div>
                                </el-col>
                            </div>
                        </el-row>
                    </div>
                </div>
            </el-col>
            <el-col :span="collapse == 0 ? 21 : 24">
                <el-container v-wechat-title="title" :style="{ height: this.screenHeight - 15 + 'px', position: 'relative' }" v-if="this.defaultSurgeryId > 0">
                    <el-aside width="300px" v-show="collapse == 0">
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                            <template v-if="validDocumentList.length > 0">
                                <div v-for="g in validDocumentList" :key="g.surgeryId" class="padding10">
                                    <div class="align-left font-size12">
                                        <span class="el-icon-location fg-primary font-size14" v-if="defaultSurgeryId == g.surgeryId"></span>
                                        申请时间：{{ (g.surgery && $moment(g.surgery.apply_time).format('YYYY/MM/DD HH:mm')) || '--' }}
                                        <span class="circle fg-red borderd" v-if="g.surgery && g.surgery.is_reoperation">再</span>
                                        <br>
                                        <span class="fg-info">【{{ g.surgery && g.surgery.surgery_status }}】：{{ (g.surgery && $moment(g.surgery.status_time).format('YYYY/MM/DD HH:mm')) || '--' }}</span>
                                    </div>
                                    <div :key="index" v-for="(item, index) in g.Children">
                                        <div class="title align-left padding5" v-if="item.Children.length > 0 || item.archivedInfo">
                                            <span class="el-icon-document"></span><b>{{ item.label }}</b
                                            >&nbsp;&nbsp;({{ item.Children.length || 1 }})
                                        </div>
                                        <div class="padding-none-v" v-if="item.Children.length>0">
                                            <div v-for="c in item.Children" :key="c.index" class="align-left cursor-pointer" @click="loadInstance(c)">
                                                <span v-if="hasPrintButton" class="cus-button is-circle" @click.stop="printDoc(c)"> <span class="el-icon-printer"></span> </span>&nbsp;&nbsp;
                                                {{ c.label }} &nbsp;&nbsp;<span class="fg-info">{{ c.createby }}</span
                                                >&nbsp;&nbsp;
                                            </div>
                                        </div>
                                        <div class="padding-none-v" v-else>
                                            <div v-if="item.archivedInfo" class="align-left cursor-pointer" @click="loadInstance(item)">
                                                <span v-if="hasPrintButton" class="cus-button is-circle" @click.stop="printDoc(item)"> <span class="el-icon-printer"></span> </span>&nbsp;&nbsp;
                                                {{ item.archivedInfo.docname }} &nbsp;&nbsp;<span class="fg-info">{{ item.archivedInfo.modifier }}</span
                                                >&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
                        </el-scrollbar>
                    </el-aside>
                    <el-main class="width-p100" style="padding: 0" v-loading="loading">
                        <div style="height: 30px; width: 100%; margin-top: 10px">
                            <i style="cursor: pointer; float: left" :class="collapse == 1 ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="triggerCollapse()"></i>
                            <div>
                                <el-link type="primary" style="font-size: larger; margin-left: 5px" @click="changescalenum(0.1)"><span class="el-icon-zoom-in" title="放大"></span></el-link>
                                <el-link type="primary" style="font-size: larger; margin-left: 5px" @click="changescalenum(-0.1)"><span class="el-icon-zoom-out" title="缩小"></span></el-link>
                            </div>
                        </div>
                        <DocFrame
                            v-if="document"
                            ref="doc"
                            :isUnLogin="true"
                            :style="{ transform: 'scale(' + scalenum + ')', 'transform-origin': 'center top' }"
                            :docno="document.docno"
                            :docbizid="document.docbizid"
                            :surgeryId="defaultSurgeryId"
                            :isSurportHtml="document.isSurportHtml"
                            :isHide="!document.archived"
                            :extraParams="document.extraParams"
                        ></DocFrame>
                        <div v-else-if="src" :style="{ width: (210*pdfScalenum)+'mm', height: (297*pdfScalenum)+'mm', 'transform-origin': 'center top', margin: 'auto', display: 'block' }">
                            <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
                        </div>
                        <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
                    </el-main>
                </el-container>
                <p v-else class="no-surgery">暂无手术</p>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import axios from 'axios'
import pdf from '@/common/vue-pdf-4.1.0'
import printJs from 'print-js'
import { mapGetters } from 'vuex'

export default {
    name: `UnloginDocument`,
    components: {
        pdf
    },
    props: {},
    data() {
        return {
            collapse: 0,
            scalenum: 1,
            pdfScalenum: parseFloat(this.$root.UnLoginPdfScaleNum || `1`),
            UnloginDocumentSurgeryStatus: this.$root.UnloginDocumentSurgeryStatus,
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            token: this.$route.query.token,
            key: this.$route.query.key,
            newkey: this.$route.query.newkey,
            docid: this.$route.query.docid,
            newdocid: this.$route.query.newdocid,
            documentList: [],
            activeDoc: undefined,
            title: `文书`,
            isTemplate: 0,
            document: {
                title: `创建文书`,
                dialogFormVisible: false,
                docno: 1,
                docname: ``,
                datetype: 2,
                templateid: undefined,
                daterange: this.$moment().format(`YYYY/MM/DD HH:mm`),
                occurdate: this.$moment().format(`YYYY/MM/DD HH:mm`),
                fromDt: this.$moment().format(`YYYY/MM/DD HH:mm`),
                toDt: this.$moment().format(`YYYY/MM/DD HH:mm`)
            },
            surgeries: [],
            hasPrintButton: false,
            defaultSurgeryId: undefined,
            screenHeight: document.documentElement.clientHeight,
            currentSurgery: {},
            surgeryId: this.defaultSurgeryId,
            loading: false,
            src: Object,
            numPages: [],
            DocumentConfig: null,
            DocArchivedList: [],
            para: this.$route.query.para,
            doctoken: null
        }
    },
    computed: {
        // ...mapGetters([`currentUser`])
        ...mapGetters([`currentUser`]),
        validDocumentList() {
            let nd = _.filter(this.documentList, d => (d.Children && d.Children.length > 0) || (!d.IsSurportHtml && d.is_show_medical))
            let r = _.reduce(
                _.groupBy(nd, `surgeryId`),
                function(result, v, key) {
                    result.push({
                        surgeryId: key,
                        surgery: v[0].surgery,
                        Children: v
                    })
                    return result
                },
                []
            )
            return _.orderBy(r, `surgery.apply_time`)
        }
    },
    created() {
        this.reload()
    },
    mounted() {

    },
    methods: {
        changescalenum(num) {
            let that = this
            let oldnum = that.document && that.scalenum || that.pdfScalenum
            var newnum = oldnum + num
            if (newnum < 1) {
                if (that.document) {
                    that.scalenum = 1
                } else {
                    that.pdfScalenum = 1
                }
                that.$message.error(`已到缩小最小值1.0倍`)
            } else if (that.document && newnum > 2) {
                that.scalenum = 2
                that.$message.error(`文书已到放大最大值2倍`)
            } else if (!that.document && newnum > 3) {
                that.pdfScalenum = 3
                that.$message.error(`pdf已到放大最大值3倍`)
            } else {
                if (that.document) {
                    that.scalenum = newnum
                } else {
                    that.pdfScalenum = newnum
                }
            }
        },
        triggerCollapse() {
            if (this.collapse == 0) {
                this.collapse = 1
            } else {
                this.collapse = 0
            }
            this.$emit(`triggerCollapse`, this.collapse)
        },
        loadToken() {
            let that = this
            if (this.newuser) {
                this.user = decodeURIComponent(window.atob(this.newuser))
            }
            if (this.newkey) {
                this.key = decodeURIComponent(window.atob(this.newkey))
            }
            if (this.newdocid) {
                this.docid = decodeURIComponent(window.atob(this.newdocid))
            }
            if (this.para) {
                let paraInfo = decodeURIComponent(window.atob(that.para))
                if (paraInfo) {
                    let paraobj = eval(
                        `(` + paraInfo + `)`
                    )
                    that.user = paraobj && paraobj.user
                    that.key = paraobj && paraobj.key
                    that.docid = paraobj && paraobj.docid
                }
            }
            return new Promise(resolve => {
                let username = this.user.split(`_`)[0]
                let password = this.user.split(`_`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    this.token = data
                    this.doctoken = this.getToken()
                    sessionStorage.setItem(`doctoken`, this.doctoken)
                    resolve(data)
                })
            })
        },
        titleLabel(item) {
            let title = `患者:${item.patient_name} 性别:${item.sex || `--`} 年龄:${item.age || `--`} 
病例号:${item.visit_no || `--`} 
术前诊断:${item.diseases}
拟施手术:${item.surgeries}
手术医生:${item.surgeon}
手术科室:${!item.dic_section ? `` : item.dic_section}
麻醉医生:${!item.plan_anes_doctor ? `` : item.plan_anes_doctor}
申请台次:${item.sequence || ``}
申请时间:${this.$moment(item.apply_time).format(`YYYY-MM-DD HH:mm:ss`)}
计划开始时间:${this.$moment(item.plan_time).format(`YYYY-MM-DD HH:mm:ss`)}
备注:${item.his_remark || ``}
传染病:${item.infectious || ``}
麻醉类型:${item.is_local_anes_val || ``}`
            return title
        },
        loadSurgeries() {
            let req = this.myaxios.get(`api/Preoperative/Apply/GetPatientListByKey?key=${this.key}`)
            let req1 = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            return new Promise(resolve => {
                this.myaxios.all(req, req1).then(([data, data2]) => {
                    if (this.UnloginDocumentSurgeryStatus && this.UnloginDocumentSurgeryStatus != `` && this.UnloginDocumentSurgeryStatus != `0`) {
                        let r1 = this.UnloginDocumentSurgeryStatus.split(`,`)
                        const statusSet = new Set(r1.map(item => item.trim())) // 去除空格
                        data = data.filter(s => statusSet.has(String(s.enum_surgery_status)))
                    }
                    this.surgeries = data
                    this.defaultSurgeryId = (data[0] && data[0].id) || 0
                    this.currentSurgery = data[0]
                    if (data2.findIndex(item => item.permission === `Document:unlogin_PrintButton`) !== -1) {
                        this.hasPrintButton = true
                    }
                    resolve()
                }).catch(e => {
                    console.log(e)
                    this.surgeries = []
                    resolve()
                })
            })
        },

        loadAssociatedOperations(id) {
            this.defaultSurgeryId = !id ? this.defaultSurgeryId : id
            if (!this.defaultSurgeryId) {
                return Promise.resolve([])
            }
            return this.myaxios.post(`api/Intraoperative/Anaesthesia/AssociatedOperations?surgeryInfoId=${this.defaultSurgeryId}`)
        },
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadDocumentList(surgeries) {
            if (!this.defaultSurgeryId || surgeries.length == 0) {
                return false
            }
            return new Promise(resolve => {
                let that = this
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: this.defaultSurgeryId }
                })
                let req2 = _.map(surgeries, d => {
                    return this.myaxios.get(`/api/Operation/Home/ArchiveList?surgeryInfoId=${d.id}`)
                })
                this.myaxios
                    .all(req, ...req2)
                    .then(([data, ...data2]) => {
                        that.documentList = _.reduce(
                            data2,
                            function(result, v, index) {
                                let r = []
                                let surgery = _.find(surgeries, { id: parseInt(v[0] && v[0].biz_surgery_info_id || that.defaultSurgeryId) })
                                if (v.length > 0) {
                                    let mzyfs = _.filter(v, x => x.enum_record_type !== 22)
                                    r = [
                                        {
                                            surgeryId: mzyfs[0].biz_surgery_info_id,
                                            surgery: surgery,
                                            index: `MZYFS`,
                                            hasChildren: true,
                                            Children:
                                        _.map(mzyfs, d => {
                                            return {
                                                surgeryId: d.biz_surgery_info_id,
                                                index: d.enum_record_type == 1 ? `MZD` : `FSD`,
                                                docno: d.enum_record_type == 1 ? -1 : -2,
                                                label: d.record_type,
                                                archiveddt: d.is_archived ? d.archive_date : ``
                                            }
                                        }) || [],
                                            label: `麻醉与复苏`
                                        }
                                    ]

                                    let qjjld = _.filter(v, x => x.enum_record_type === 22)
                                    if (qjjld.length > 0) {
                                        r.push({
                                            surgeryId: qjjld && qjjld[0].biz_surgery_info_id,
                                            surgery: surgery,
                                            index: `QJJLD`,
                                            hasChildren: true,
                                            Children:
                                            _.map(qjjld, d => {
                                                return {
                                                    surgeryId: d.biz_surgery_info_id,
                                                    index: `QJD`,
                                                    docno: -3,
                                                    label: d.record_type,
                                                    archiveddt: d.is_archived ? d.archive_date : ``
                                                }
                                            }) || [],
                                            label: `抢救记录单`
                                        })
                                    }
                                }

                                r = r.concat(
                                    _.map(data.data, dr => {
                                        let docconfig = that.DocumentConfig && _.find(that.DocumentConfig, d3 => d3.document_id == dr.DocNo)
                                        let d = { ...dr }
                                        d.is_show_medical = docconfig && docconfig.is_show_medical
                                        d.surgeryId = v[0] && v[0].biz_surgery_info_id || that.defaultSurgeryId
                                        d.surgery = surgery
                                        d.index = `${d.DocNo}`
                                        d.hasChildren = d.IsSurportHtml
                                        d.Children = []
                                        d.label = d.DocName
                                        if (!d.IsSurportHtml && d.is_show_medical) {
                                            d.archivedInfo = that.DocArchivedList && _.find(that.DocArchivedList, da => parseInt(da.docid) == parseInt(d.DocId || d.DocNo) && da.biz_surgeryInfo_id == parseInt(d.surgeryId))
                                        }
                                        return d
                                    })
                                )
                                result.push(...r)
                                return result
                            },
                            []
                        )
                        resolve(
                            _.forEach(this.documentList, d => {
                                if (d.hasChildren && d.DocNo > 0) {
                                    this.loadInstances(d.index, d.surgeryId)
                                }
                            }))
                        console.log(`documentList`, that.documentList)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        loadInstance(doc) {
            if (doc.docno > 0) {
                this.src = undefined
                this.document = {
                    docno: doc.docno,
                    docbizid: doc.docbizid
                }
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            } else if (doc.DocNo > 0) {
                this.src = undefined
                this.document = {
                    docno: doc.DocNo,
                    surgeryId: doc.surgeryId,
                    isSurportHtml: doc.IsSurportHtml,
                    archived: doc.archivedInfo && doc.archivedInfo.archivedt
                }
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            } else {
                this.document = undefined
                this.loading = true
                let req = ``
                if (doc.archiveddt.length > 0) {
                    req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${doc.surgeryId}&recordType=${doc.index == `MZD` ? 1 : (doc.index == `QJD` ? 22 : 2)}`)
                } else {
                    req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${doc.surgeryId}&recordType=${doc.index == `MZD` ? 1 : (doc.index == `QJD` ? 22 : 2)}`)
                }
                req.then(data => {
                    this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                    this.src.then(content => {
                        this.numPages = content.numPages
                        this.loading = false
                    })
                }).catch(e => {
                    console.log(e)
                    this.loading = false
                })
            }
        },
        loadInstances(docno, surgeryId) {
            let submenu = _.find(this.documentList, d => {
                return d.DocNo == docno && d.surgeryId == surgeryId
            })
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` },
                params: { docid: docno, dept: `acis2020`, vid: surgeryId }
            })
            req.then(data => {
                submenu.Children = _.filter(data.Content, d => {
                    return d.istemplate == `0`
                }).map(d => {
                    d.index = `${d.docbizid}`
                    d.docno = submenu.DocNo
                    d.label = d.docname
                    return d
                })
            })
        },
        getinfo(docno, surgeryId) {
            let that = this
            let submenu = null
            if (docno < 0) {
                this.src = null
                submenu = _.find(this.documentList, d => {
                    return d.index == `MZYFS` && d.surgeryId == surgeryId
                })
                if (!submenu || submenu.Children.length == 0) return
                let info = _.find(submenu.Children, d => {
                    return d.docno == docno
                })
                if (info) {
                    that.loadInstance(info)
                }
            } else {
                submenu = _.find(this.documentList, d => {
                    return d.DocNo == docno && d.surgeryId == surgeryId
                })
                if (!submenu) return
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docid: submenu.DocId, dept: `acis2020`, vid: surgeryId }
                })
                req.then(data => {
                    let Children = _.filter(data.Content, d => {
                        return d.istemplate == `0`
                    })
                    let info = Children && Children[0]
                    if (info) {
                        info.docno = submenu.DocNo
                        that.loadInstance(info)
                    }
                })
            }
        },
        printDoc(c) {
            console.log(c)
            let that = this
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                if (c.docno > 0 || c.DocNo > 0) {
                    that.document.extraParams = { isShowSendPrintMessage: isShow.value }
                    this.$refs.doc.print()
                    // this.$store.dispatch(`PRINT_PDF`, {
                    //     host: this.$root.DOCSERVICE_BASE,
                    //     params: Object.assign(
                    //         {
                    //             docid: c.docid || c.docno,
                    //             id1: this.surgeryId,
                    //             docbizid: c.docbizid,
                    //             from: this.$moment().format(`YYYYMMDDHHmm`),
                    //             to: this.$moment().format(`YYYYMMDDHHmm`)
                    //         },
                    //         { isShowSendPrintMessage: isShow.value }
                    //     )
                    // })
                } else {
                    let req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${c.surgeryId}&recordType=${c.index == `MZD` ? 1 : (c.index == `QJD` ? 22 : 2)}`)
                    req.then(data => {
                        req.then(data => {
                            printJs({ printable: data,
                                type: `pdf`,
                                base64: true,
                                onPrintDialogClose: () => {
                                    if (isShow.value === `true`) {
                                        setTimeout(function() {
                                            that.$confirm(`提示`, {
                                                title: `提示`,
                                                message: `请确认打印是否已完成`,
                                                confirmButtonText: `打印完成`,
                                                cancelButtonText: `打印未完成`,
                                                type: `warning`
                                            }).then(() => {

                                            }).catch(e => {
                                                console.log(e)
                                            })
                                        }, 2000)
                                    }
                                } })
                        }).catch(e => console.log(e))
                    }).catch(e => {
                        console.log(e)
                        this.loading = false
                    })
                }
            }).catch(e => {
                console.log(e)
            })
        },
        ReloadDocument(id) {
            let that = this
            that.loadAssociatedOperations(id).then(surgeries => {
                that.loadDocArchived(surgeries).then(info => {
                    that.loadDocumentConfig().then(config => {
                        that.loadDocumentList(surgeries)
                    })
                })
            })
        },
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                req.then(DocumentConfig => {
                    that.DocumentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        loadDocArchived(surgeries) {
            let that = this
            return new Promise((resolve, reject) => {
                let req = _.map(surgeries, d => {
                    return this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetArchivedBySurgeryId?surgeryId=${d.id}`)
                })
                this.myaxios.all(...req).then(([...data]) => {
                    that.DocArchivedList = _.reduce(data, function(result, v, index) {
                        result.push(...v)
                        return result
                    }, [])
                    console.log(`DocArchivedList`, that.DocArchivedList)
                    resolve(that.DocArchivedList)
                })
            })
        },
        reload() {
            let that = this
            this.loadToken().then(() => {
                this.$store.dispatch(`ADD_CURRENTUSER`)
                that.loadSurgeries().then(() => {
                    that.loadAssociatedOperations().then(surgeries => {
                        that.loadDocArchived(surgeries).then(info => {
                            that.loadDocumentConfig().then(config => {
                                that.loadDocumentList(surgeries).then(() => {
                                    if (that.docid) {
                                        that.getinfo(parseInt(that.docid), that.defaultSurgeryId)
                                    }
                                })
                            })
                        })
                    })
                })
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.key = newUrl.query.key
            this.docid = newUrl.query.docid
            this.reload()
        }
    }
}
</script>
<style scoped lang="less" >
// @h-header: 30px;
// .pdf {
//     width: 100%;
//     height: 100%;
//     padding: @h-header 0px;
// }
// .pdf-header {
//     line-height: @h-header;
//     background: whitesmoke;
//     position: absolute;
//     width: 100%;
//     height: @h-header;
//     z-index: 2;
// }
ul,
li {
    list-style: none;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
.surgery-patient-list:hover {
    background: rgba(144, 147, 153, 0.3);
    color: #fff;
}
.surgeryActive {
    background: var(--primary-color, #009688);
    color: #fff;
}
.pdf-page {
  /* Set A4 paper size styles */
  width: 210mm; /* A4 width */
  height: 297mm; /* A4 height */
  margin: auto;
  display: block;
}
</style>
<style lang="less">
.document-list {
    .el-submenu__icon-arrow {
        // position: absolute !important;
        left: -220px;
    }
    .btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -12px;
        font-size: 16px;
        z-index: 2;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Document/UnloginDocument.vue